import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Mail } from "lucide-react";
import { api } from "@/lib/api";
import Seo from "@/components/Seo";

export default function Newsletter() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    api.get("/newsletter/archive").then(r => setItems(r.data)).catch(() => setItems([]));
  }, []);

  return (
    <div className="min-h-screen pt-32" data-testid="newsletter-archive-page">
      <Seo title="Newsletter" description="Every AI update we've emailed to subscribers — see what lands in the inbox before you join." path="/newsletter" />
      <header className="max-w-7xl mx-auto px-4 md:px-6 py-16 md:py-24">
        <div className="inline-flex items-center gap-2 border border-white/15 bg-white/5 rounded-full px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.14em] text-orange-300 mb-6">
          <Mail size={12} /> Sent to subscribers
        </div>
        <h1 className="font-display font-bold tracking-tight text-5xl sm:text-6xl lg:text-7xl text-white">Newsletter</h1>
        <p className="mt-5 text-slate-200 max-w-xl text-sm md:text-base leading-relaxed">
          Every update we've emailed to subscribers — see exactly what lands in the inbox before you join.
        </p>
      </header>

      <section className="max-w-7xl mx-auto px-4 md:px-6 pb-24">
        {items === null && <div className="text-slate-200">Loading…</div>}

        {items && items.length === 0 && (
          <div className="card-void p-10 text-center max-w-xl mx-auto" data-testid="archive-empty">
            <div className="font-display font-semibold text-white text-lg">No email updates sent yet</div>
            <p className="mt-2 text-sm text-slate-200">Subscribe below and you'll be first in line when the next one goes out.</p>
          </div>
        )}

        {items && items.length > 0 && (
          <div className="divide-y divide-white/10 border-t border-b border-white/10">
            {items.map((n) => {
              const internal = n.is_article && n.slug;
              const inner = (
                <>
                  <div className="flex items-center gap-3 shrink-0">
                    <span className="meta-mono w-24">
                      {new Date(n.emailed_at).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })}
                    </span>
                    <span className="chip hidden sm:inline-flex">{n.category}</span>
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="font-display font-semibold text-white text-base md:text-lg leading-snug group-hover:text-orange-200 transition-colors">
                      {n.title}
                    </div>
                    {n.summary && <p className="mt-1 text-sm text-slate-200 line-clamp-1">{n.summary}</p>}
                  </div>
                  <ArrowUpRight size={18} className="text-slate-200 group-hover:text-orange-400 transition-colors shrink-0" />
                </>
              );
              const cls = "py-5 flex items-center gap-4 group";
              return internal ? (
                <Link key={n.id} to={`/news/${n.slug}`} className={cls} data-testid={`archive-row-${n.id}`}>
                  {inner}
                </Link>
              ) : (
                <a key={n.id} href={n.url} target="_blank" rel="noreferrer" className={cls} data-testid={`archive-row-${n.id}`}>
                  {inner}
                </a>
              );
            })}
          </div>
        )}
      </section>
    </div>
  );
}
